"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagNameInputState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var store_1 = require("../../store");
var autocomplete_menu_1 = require("../autocomplete.menu/autocomplete.menu");
var mithril_component_1 = require("../mithril.component");
var input_1 = require("./input");
var input_state_1 = require("./input.state");
var TagNameInputState = /** @class */ (function (_super) {
    tslib_1.__extends(TagNameInputState, _super);
    function TagNameInputState() {
        var _this = _super.call(this) || this;
        _this.state = new input_state_1.InputState(i18n_1.T.TAG_NAME);
        _this.menu = new autocomplete_menu_1.AutoCompleteMenu({
            inputState: _this.state,
            options: function () { return _this.autoCompleteOptions; },
            onselect: function (opt) { return _this.accept(opt.id); },
            showNew: true
        });
        return _this;
    }
    Object.defineProperty(TagNameInputState.prototype, "value", {
        get: function () {
            return this.state.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagNameInputState.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { className: 'c-TagInput' }, [
                input_1.Input.view(this.state),
                this.menu.view()
            ]);
        },
        enumerable: false,
        configurable: true
    });
    TagNameInputState.prototype.accept = function (value) {
        if (value) {
            this.state.setValue(value);
        }
    };
    Object.defineProperty(TagNameInputState.prototype, "autoCompleteOptions", {
        get: function () {
            var tags = [];
            for (var _i = 0, _a = store_1.AppStore.Tag.all; _i < _a.length; _i++) {
                var tag = _a[_i];
                var tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
                if (tagSummary == null || tagSummary.revisions.length === 0) {
                    continue;
                }
                tags.push({ id: tag.name, value: tag.name });
            }
            return tags;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TagNameInputState.prototype, "accept", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagNameInputState.prototype, "autoCompleteOptions", null);
    return TagNameInputState;
}(mithril_component_1.IMithrilStateComponent));
exports.TagNameInputState = TagNameInputState;
//# sourceMappingURL=tag.input.state.js.map